<div class="grid grid-cols-5 gap-2">
  <div class="col-span-4">
    <input type="text" [disabled]="disabled" tailInput #i="input" ipHistoryModel [(ngModel)]="value"
           (ngModelChange)="valueChange.next(i.el.value)"
           placeholder="Color" i18n-placeholder="@@color">
  </div>
 <div class="rounded" [style.background-color]="value" style="overflow: hidden">
   <input class="col-span-1 h-full rounded border py-0" type="color" [(ngModel)]="value" style="width: 119%; margin-left: -6px; margin-top: -6px; height: 150%">
 </div>
</div>
<p tailHint i18n="@@leave_empty_for_transparent">Leave empty to make it transparent</p>
